<template>
    <ul class="link_list">
		<li><a href="javascript:location.href='https://l-tike.com/contact/'" title="" ><span class="item_label">ローソンチケット
                                      お問い合わせ</span></a></li>
		<li><a href="javascript:location.href='https://www.hmv.co.jp/help/'" title="" ><span class="item_label">HMV & Books
                                      お問い合わせ</span></a></li>
<!--		<li><a href="javascript:location.href='https://www.lawson.co.jp/service/receive/loppick/-->
<!--'" title="" ><span class="item_label">ローソンフレッシュピック</span></a></li>-->
		<li><a href="javascript:location.href='https://www.lawson.co.jp/company/activity/'" title="" ><span class="item_label">環境保全・社会活動</span></a></li>
		<li><a href="javascript:location.href='https://www.lawson.co.jp/company/fc/'" title="" ><span class="item_label">フランチャイズ加盟</span></a></li>
		<li><a href="javascript:location.href='https://www.lawson.co.jp/company/fc/foi/'" title="" ><span class="item_label">FCオーナー・インターン制度</span></a></li>
		<li><a href="javascript:location.href='http://www.lawson.co.jp/company/branch/property/'" title="" ><span class="item_label">土地建物有効活用・物件募集</span></a></li>
		<li><a href="javascript:location.href='http://www.lawson.co.jp/company/ir/'" title="" ><span class="item_label">IR・株式</span></a></li>
		<li><a href="javascript:location.href='https://www.lawson.co.jp/company/activity/governance/privacy/'" title="" ><span class="item_label">個人情報保護方針</span></a></li>
        <li><span class="item_label"></span></li>
	</ul>
</template>

<script>
export default {
	name: 'relatedLinkList',
}
</script>

<style scoped>
.item_label {
  width: 100%;
}
.link_list {
  margin-top: 30px;
  border-top: 1px solid #d9d9d9;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.link_list li {
  border-top: 1px solid #076cb9;
  width: 33%;
  -ms-flex: 0 1 auto;
  white-space: pre-line;
}
.link_list li a {
  color: #076cb9;
  font-size: 16px;
  font-weight: bold;
  height: 60px;
  padding: 0px;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.link_list li a:hover {
  color: #63b2ed;
  border: 1px solid #63b2ed;
  background: #fafdff;
}
@media screen and (max-width: 798px) {
  .link_list li {
    width: 48%;
  }
}
@media screen and (max-width: 510px) {
  .link_list li {
    width: 100%;
  }
}
</style>
